import { AvailableCredit, InputText, StepStateUpdater } from '@applyonline/shared'
import { formatCurrency } from '@if/core/utils'
import { useEffect } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { WorksheetForm } from '../../../containers/Worsheet/schema-hooks'

interface Props {
  maxAmountFinanced: number
  availableCredit: AvailableCredit | undefined
  setStepState: StepStateUpdater
}

const FinalAmountStep = ({ maxAmountFinanced, availableCredit, setStepState }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext<WorksheetForm>()
  const {
    field,
    fieldState: { error, invalid },
  } = useController({
    name: 'amountRequested',
    control,
  })

  useEffect(() => setStepState({ invalid }), [invalid, setStepState])

  return (
    <>
      <h3 style={{ marginBottom: '16px' }}>
        <i className="fa-solid fa-party-horn" />{' '}
        <Trans
          i18nKey="worksheet.finalAmount.title"
          values={{
            maxLoanAmount: formatCurrency(maxAmountFinanced),
          }}
        />
      </h3>
      {availableCredit && availableCredit.creditInProgress !== 0 && (
        <>
          <h4>
            <Trans
              i18nKey="worksheet.finalAmount.activeCredit"
              values={{ creditInProgress: formatCurrency(availableCredit.creditInProgress) }}
            />
          </h4>
          <h4 style={{ marginBottom: '16px' }}>
            <strong style={{ color: 'var(--accent-blue)' }}> {formatCurrency(availableCredit.availableAmount)} </strong>
            <Trans i18nKey="worksheet.finalAmount.availableCredit" />
          </h4>
        </>
      )}
      <h4 style={{ marginBottom: '16px' }}>{t('worksheet.finalAmount.confirmation')}</h4>
      <InputText
        error={error}
        label={t('worksheet.finalAmount.label')}
        id="amountRequested"
        type="number"
        inputMode="decimal"
        {...field}
      />
    </>
  )
}

export default FinalAmountStep
